// MUI Base Styles
import colors from "../../base/colors";
import borders from "../../base/borders";
import boxShadows from "../../base/boxShadows";

// MUI Helper Function
import rgba from "../../functions/rgba";

const {black, white} = colors;
const {borderWidth, borderRadius} = borders;
const {cardBoxShadow} = boxShadows;

const card: any = {
    styleOverrides: {
        root: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            minWidth: 0,
            wordWrap: "break-word",
            backgroundColor: white.main,
            backgroundClip: "border-box",
            border: `${borderWidth[0]} solid ${rgba(black.main, 0.125)}`,
            borderRadius: borderRadius.xl,
            boxShadow: cardBoxShadow,
        },
    },
};

export default card;
